var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "register" },
    [
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.isValid,
            callback: function ($$v) {
              _vm.isValid = $$v
            },
            expression: "isValid",
          },
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("h1", { staticClass: "text-center bot-color-blue" }, [
                    _vm._v(
                      "\n                    Đăng ký thành viên\n                "
                    ),
                  ]),
                  _c("bot-upload-images", {
                    ref: "botImg",
                    class: _vm.action,
                    model: {
                      value: _vm.avatar,
                      callback: function ($$v) {
                        _vm.avatar = $$v
                      },
                      expression: "avatar",
                    },
                  }),
                  _vm.snackbar.visible
                    ? _c("v-alert", { attrs: { type: _vm.snackbar.color } }, [
                        _vm._v(_vm._s(_vm.snackbar.text)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c("v-col", { attrs: { cols: "8" } }, [
                _vm.action === "adding"
                  ? _c(
                      "div",
                      { staticClass: "register-form-adding" },
                      [
                        _c(
                          "bot-spinner",
                          {
                            model: {
                              value: _vm.spinner,
                              callback: function ($$v) {
                                _vm.spinner = $$v
                              },
                              expression: "spinner",
                            },
                          },
                          [
                            _c(
                              "fieldset",
                              [
                                _c("legend", [_vm._v("Thông tin shop")]),
                                _c(
                                  "v-list-item",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        autofocus: "",
                                        label: "Số điện thoại",
                                        type: "number",
                                        rules: [_vm.vld.phoneNumber],
                                      },
                                      model: {
                                        value: _vm.vAdding.PhoneNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.vAdding,
                                            "PhoneNumber",
                                            $$v
                                          )
                                        },
                                        expression: "vAdding.PhoneNumber",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Tên shop",
                                        rules: [
                                          (value) =>
                                            _vm.vld.text({
                                              field: "tên shop",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.vAdding.ConsignorName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.vAdding,
                                            "ConsignorName",
                                            $$v
                                          )
                                        },
                                        expression: "vAdding.ConsignorName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Tên người liên hệ",
                                        rules: [
                                          (value) =>
                                            _vm.vld.text({
                                              field: "tên người liên hệ",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.vAdding.MemberName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.vAdding,
                                            "MemberName",
                                            $$v
                                          )
                                        },
                                        expression: "vAdding.MemberName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Email",
                                        rules: [
                                          (value) => _vm.vld.email(value),
                                        ],
                                      },
                                      model: {
                                        value: _vm.vAdding.Email,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.vAdding, "Email", $$v)
                                        },
                                        expression: "vAdding.Email",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        attrs: { label: "Giới tính", row: "" },
                                        model: {
                                          value: _vm.vAdding.Gender,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.vAdding, "Gender", $$v)
                                          },
                                          expression: "vAdding.Gender",
                                        },
                                      },
                                      [
                                        _c("v-radio", {
                                          attrs: {
                                            value: 1,
                                            label: "nam",
                                            color: "success",
                                          },
                                        }),
                                        _c("v-radio", {
                                          attrs: {
                                            value: 2,
                                            label: "nữ",
                                            color: "red",
                                          },
                                        }),
                                        _c("v-radio", {
                                          attrs: {
                                            value: 0,
                                            label: "khác",
                                            color: "warning",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("v-spacer"),
                                    _c("bot-date-picker", {
                                      attrs: {
                                        options: _vm.options.DateOfBirth,
                                      },
                                      model: {
                                        value: _vm.vAdding.DateOfBirth,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.vAdding,
                                            "DateOfBirth",
                                            $$v
                                          )
                                        },
                                        expression: "vAdding.DateOfBirth",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-2",
                                    attrs: { color: "primary" },
                                    on: { click: _vm.submit },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Đăng ký\n                                "
                                    ),
                                    _c("v-icon", { attrs: { right: "" } }, [
                                      _vm._v(" mdi-check "),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                ["activating", "activated"].includes(_vm.action)
                  ? _c(
                      "div",
                      { staticClass: "register-form-activating" },
                      [
                        _c(
                          "bot-spinner",
                          {
                            model: {
                              value: _vm.spinner,
                              callback: function ($$v) {
                                _vm.spinner = $$v
                              },
                              expression: "spinner",
                            },
                          },
                          [
                            _c("table", { staticClass: "table" }, [
                              _c("tr", [
                                _c("th", [_vm._v("Số điện thoại:")]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.vAdding.PhoneNumber)),
                                ]),
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Tên shop:")]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.vAdding.ConsignorName)),
                                ]),
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Người liên hệ:")]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.vAdding.MemberName)),
                                ]),
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Email:")]),
                                _c("td", [_vm._v(_vm._s(_vm.vAdding.Email))]),
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Giới tính:")]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.vAdding.GenderLabel)),
                                ]),
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("Ngày sinh:")]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.vAdding.DateOfBirthLabel)),
                                ]),
                              ]),
                            ]),
                            _vm.action === "activating"
                              ? _c(
                                  "fieldset",
                                  [
                                    _c("legend", [
                                      _vm._v(
                                        "\n                                Nhập mã kích hoạt và tạo mật khẩu\n                            "
                                      ),
                                    ]),
                                    _c(
                                      "v-list-item",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            autofocus: "",
                                            label: "Mã kích hoạt",
                                            rules: [
                                              (value) =>
                                                _vm.vld.text({
                                                  field: "mã kích hoạt",
                                                  value,
                                                }),
                                            ],
                                          },
                                          model: {
                                            value: _vm.vActive.ActiveCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.vActive,
                                                "ActiveCode",
                                                $$v
                                              )
                                            },
                                            expression: "vActive.ActiveCode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Mật khẩu",
                                            type: "password",
                                            rules: [
                                              (value) =>
                                                _vm.vld.text({
                                                  field: "mật khẩu",
                                                  value,
                                                }),
                                            ],
                                          },
                                          model: {
                                            value: _vm.vActive.Password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.vActive,
                                                "Password",
                                                $$v
                                              )
                                            },
                                            expression: "vActive.Password",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Nhập lại mật khẩu",
                                            type: "password",
                                            rules: [
                                              (value) =>
                                                _vm.vld.text({
                                                  field: "lại mật khẩu",
                                                  value,
                                                }),
                                              (value) =>
                                                (!!value &&
                                                  value ===
                                                    _vm.vActive.Password) ||
                                                "Mật khẩu và nhập lại mật khẩu chưa giống nhau!",
                                            ],
                                          },
                                          model: {
                                            value: _vm.vActive.ConfirmPassword,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.vActive,
                                                "ConfirmPassword",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "vActive.ConfirmPassword",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.action === "activating"
                              ? _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-2",
                                        attrs: { color: "success" },
                                        on: { click: _vm.handleActive },
                                      },
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v(" mdi-send "),
                                        ]),
                                        _vm._v(
                                          "\n                                Kích hoạt\n                            "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/authen/register.vue